import { CommonModule } from '@angular/common';
import { COMMON } from 'app/core/constants/common';
import { ChatbotService } from '../chatbot.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import {
    Component,
    ElementRef,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { InputGeneralComponent } from 'app/components/input-general/input-general.component';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-business-form',
    templateUrl: './business-form.component.html',
    styleUrls: ['./business-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        FormsModule,
        CommonModule,
        RouterModule,
        MatIconModule,
        FooterComponent,
        HeaderComponent,
        MatButtonModule,
        MatDialogModule,
        TranslateModule,
        ReactiveFormsModule,
        InputGeneralComponent,
    ],
    standalone: true,
})
export class BusinessFormComponent {
    isRequired: any;
    digitOnlyError: any;
    isRequiredError: any;
    languageSelected: any;
    loggedInUserData: any;
    phoneNoMinMaxError: any;

    businessCardForm: FormGroup;

    clicked: boolean = false;
    submitted: boolean = false;
    clickedOutside: boolean = false;
    submittedSuccessfully: boolean = false;

    fileName: string = '';
    closeTostr: string;
    businessCardSuccessMsg: string;

    attachment: any;

    @ViewChild('firstName') firstName: ElementRef<HTMLInputElement>;
    @ViewChild('lastName') lastName: ElementRef<HTMLInputElement>;
    @ViewChild('phoneNumber') phoneNumber: ElementRef<HTMLInputElement>;
    @ViewChild('email') email: ElementRef<HTMLInputElement>;

    @ViewChild('jobTitle', { static: false }) jobTitle: ElementRef;
    @ViewChild('company', { static: false }) company: ElementRef;
    @ViewChild('address', { static: false }) address: ElementRef;
    @ViewChild('address2', { static: false }) address2: ElementRef;
    @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private translate: TranslateService,
        private chatbotService: ChatbotService,
        private toastr: ToastrService,
    ) {
        this.route.queryParams.subscribe((params) => {
            this.languageSelected = params.lang;
        });

        if (localStorage?.getItem('profile')) {
            let userDataTemp = localStorage?.getItem('profile');
            let userData = atob(userDataTemp);
            this.loggedInUserData = JSON.parse(userData);
        }
    }

    ngOnInit() {
        this.businessCardForm = this.fb.group({
            firstName: [''],
            lastName: [''],
            phoneNumber: [
                this.loggedInUserData ? this.loggedInUserData?.phoneNumber : '',
            ],
            email: [this.loggedInUserData ? this.loggedInUserData?.email : ''],
            jobTitle: [''],
            company: [''],
            address: [''],
            address2: [''],
        });

        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });

        this.translate
            .get('CONTACT_US.ENQUIRY_SUCCESS')
            .subscribe((data: any) => {
                this.businessCardSuccessMsg = data;
            });
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    switchLanguageHandler(data: any) {
        this.languageSelected = data;
    }

    get f() {
        return this.businessCardForm.controls;
    }

    addValidators() {
        this.businessCardForm
            .get('firstName')
            .setValidators([
                Validators.required,
                Validators.pattern(COMMON.NAME_PATTERN),
                Validators.minLength(COMMON.NAME_MIN_LENGTH),
                Validators.maxLength(COMMON.NAME_MAX_LENGTH),
            ]);
        this.businessCardForm.get('firstName').updateValueAndValidity();

        this.businessCardForm
            .get('lastName')
            .setValidators([
                Validators.required,
                Validators.pattern(COMMON.NAME_PATTERN),
                Validators.minLength(COMMON.NAME_MIN_LENGTH),
                Validators.maxLength(COMMON.NAME_MAX_LENGTH),
            ]);
        this.businessCardForm.get('lastName').updateValueAndValidity();

        this.businessCardForm
            .get('phoneNumber')
            .setValidators([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(17),
            ]);
        this.businessCardForm.get('phoneNumber').updateValueAndValidity();

        this.businessCardForm
            .get('email')
            .setValidators([
                Validators.required,
                Validators.pattern(COMMON.EMAIL_PATTERN),
                Validators.maxLength(COMMON.EMAIL_MAX_LENGTH),
            ]);
        this.businessCardForm.get('email').updateValueAndValidity();

        this.businessCardForm
            .get('jobTitle')
            .setValidators([Validators.maxLength(COMMON.JOB_MAX_LENGTH)]);
        this.businessCardForm.get('jobTitle').updateValueAndValidity();

        this.businessCardForm
            .get('company')
            .setValidators([
                Validators.maxLength(COMMON.COMPANY_NAME_MAX_LENGTH),
            ]);
        this.businessCardForm.get('company').updateValueAndValidity();

        this.businessCardForm
            .get('address')
            .setValidators([Validators.maxLength(COMMON.ADDRESS_MAX_LENGTH)]);
        this.businessCardForm.get('address').updateValueAndValidity();

        this.businessCardForm
            .get('address2')
            .setValidators([Validators.maxLength(COMMON.ADDRESS_MAX_LENGTH)]);
        this.businessCardForm.get('address2').updateValueAndValidity();
    }

    removeValidators() {
        this.businessCardForm.get('firstName').clearValidators();
        this.businessCardForm.get('firstName').updateValueAndValidity();

        this.businessCardForm.get('lastName').clearValidators();
        this.businessCardForm.get('lastName').updateValueAndValidity();

        this.businessCardForm.get('phoneNumber').clearValidators();
        this.businessCardForm.get('phoneNumber').updateValueAndValidity();

        this.businessCardForm.get('email').clearValidators();
        this.businessCardForm.get('email').updateValueAndValidity();

        this.businessCardForm.get('jobTitle').clearValidators();
        this.businessCardForm.get('jobTitle').updateValueAndValidity();

        this.businessCardForm.get('company').clearValidators();
        this.businessCardForm.get('company').updateValueAndValidity();

        this.businessCardForm.get('address').clearValidators();
        this.businessCardForm.get('address').updateValueAndValidity();

        this.businessCardForm.get('address2').clearValidators();
        this.businessCardForm.get('address2').updateValueAndValidity();
    }

    onSubmit() {
        let localLang = localStorage.getItem('language');
        this.submitted = true;
        this.addValidators();
        let address =
            this.businessCardForm.value.address +
            ' ' +
            this.businessCardForm.value.address2;

        if (this.businessCardForm.valid) {
            const formData: FormData = new FormData();
            formData.append('firstName', this.businessCardForm.value.firstName);
            formData.append('lastName', this.businessCardForm.value.lastName);
            formData.append(
                'phoneNumber',
                this.businessCardForm.value.phoneNumber
            );
            formData.append('company', this.businessCardForm.value.company);
            formData.append('address', address);
            if (this.attachment) {
                formData.append(
                    'file',
                    this.attachment ? this.attachment : null,
                    this.fileName ? this.fileName : null
                );
                formData.append('alias', 'BIZCARD');
            }
            formData.append('jobTitle', this.businessCardForm.value.jobTitle);
            formData.append('email', this.businessCardForm.value.email);

            this.clicked = true;
            this.chatbotService
                .submitBusinessCard('false', formData)
                .subscribe({
                    next: (data) => {
                        this.submittedSuccessfully = true;
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        this.businessCardForm.reset();
                        this.removeValidators();
                        setTimeout(() => {
                            this.router.navigate(['home']);
                        }, 1500);
                    },
                    error: (error) => {
                        if (localLang == 'en') {
                            if (
                                error.error.message ==
                                'File extension doesnot match'
                            ) {
                                this.snackBarFunct(
                                    'File extension does not match',
                                    'error'
                                );
                            } else if (error.status == 0) {
                                this.snackBarFunct(
                                    'File size exceeds the max limit of 5MB.',
                                    'error'
                                );
                            } else {
                                this.snackBarFunct(
                                    error.error.message,
                                    'error'
                                );
                            }
                        } else {
                            if (
                                error.error.message ==
                                'File size exceeds the max limit of 5242880 bytes'
                            ) {
                                this.snackBarFunct(
                                    'Saiz fail melebihi had (5MB). Sila muatnaik fail yang lebih kecil.',
                                    'error'
                                );
                            } else if (
                                error.error.message ==
                                'Media Type is not supported'
                            ) {
                                this.snackBarFunct(
                                    'Jenis Media tidak disokong',
                                    'error'
                                );
                            } else if (error.status == 0) {
                                this.snackBarFunct(
                                    'Saiz fail melebihi had (5MB). Sila muatnaik fail yang lebih kecil.',
                                    'error'
                                );
                            } else {
                                this.snackBarFunct(
                                    error.error.message,
                                    'error'
                                );
                            }
                        }
                    },
                });
        } else {
            for (const key of Object.keys(this.f)) {
                if (this.f[key].invalid) {
                    if (key == 'firstName') {
                        this.firstName.nativeElement.focus();
                    } else if (key == 'lastName') {
                        this.lastName.nativeElement.focus();
                    } else if (key == 'email') {
                        this.email.nativeElement.focus();
                    } else if (key == 'phoneNumber') {
                        this.phoneNumber.nativeElement.focus();
                    } else if (key == 'jobTitle') {
                        this.jobTitle.nativeElement.focus();
                    } else if (key == 'company') {
                        this.company.nativeElement.focus();
                    } else if (key == 'address') {
                        this.address.nativeElement.focus();
                    } else if (key == 'address2') {
                        this.address2.nativeElement.focus();
                    }
                    break;
                }
            }
        }
    }

snackBarFunct(message: string, type: 'success' | 'error') {
  const types = {
    success: () => this.toastr.success(message),
    error: () => this.toastr.error(message),
  };

    if (types[type]) {
    return types[type](); // call the appropriate toastr method
  }
}

    getErrors(input: any, inputName?: any): Array<any> {
        let errors = [];

        if (this.f[input].touched || this.submitted) {
            if (this.f[input].errors?.required) {
                errors.push(inputName + ' ' + this.isRequired);
            }
        }
        return errors;
    }

    onFileSelected(event) {
        this.clicked = false;
        const file: File = event.target.files[0];
        if (file) {
            this.fileName = file.name;
            this.attachment = file;
        }
    }

    cancelUpload() {
        this.fileUpload.nativeElement.value = null;
        this.attachment = null;
        this.fileName = '';
        this.clicked = false;
    }

    updateSubmitButton() {
        this.clicked = false;
    }

    keyPressNumbers(event) {
        const inputValue = event.target.value;
        let numericVal = '';
        numericVal = inputValue.replace(/\D/g, '');

        if (numericVal.length < 6) {
            numericVal = inputValue.replace(/\D/g, '');
        }

        if (numericVal.length >= 6) {
            if (numericVal.length >= 6 && numericVal.length < 10) {
                numericVal = inputValue.replace(
                    /(\d{1})(\d{3})(\d{2})/,
                    '+(6$1) $2 $3'
                );
            } else if (numericVal.length == 10) {
                numericVal = inputValue.replace(
                    /(\d{1})(\d{4})(\d{4})/,
                    '+(6$1) $2 $3'
                );
            } else if (numericVal.length > 10) {
                numericVal = inputValue
                    .replace(/\D/g, '')
                    .replace(/(\d{2})(\d{4})(\d{4})/, '+($1) $2 $3');
            }
        }

        /* CHECK IF NUMERICVAL INPUT HAVING ALPHABETS / SPECIAL CHARACTERS AFTER PATTERN */
        if (/[^a-zA-Z`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(numericVal)) {
            numericVal = numericVal.replace(
                /[A-Za-z`!@#$%^&*_\-=\[\]{};':"\\|,.<>\/?~]/,
                ''
            );
        }

        event.target.value = numericVal;
    }

    pasteNumberOnly(event) {
        let clipboardData = event.clipboardData;
        let pastedData = clipboardData.getData('Text');
        if (isNaN(pastedData)) {
            event.preventDefault();
        } else {
            return;
        }
    }

    alphaNumberOnly(e) {
        const inputValue = e.target.value;
        let val = '';
        val = inputValue.replace(/[^a-z0-9A-Z0-9 ]/g, '');
        val = val === '' ? null : val;
        e.target.value = val;
    }

    alphabetOnly(e) {
        const inputValue = e.target.value;
        let val = '';
        val = inputValue.replace(/[^a-zA-Z ]/g, '');
        val = val === '' ? null : val;
        e.target.value = val;
    }
}
